import React from 'react';
import './style.css';
import { API_URL } from '../../constants/config';
import pdfIcon from '../../assets/icon_pdf.png';

function FileList({ files }) {
  if(!files.length) return null;
  return (
    <div className="file-list-content">
      {files.map((file, index) => (
        <React.Fragment key={file.id || index}>
          <div className="file-list-row">
            <h3>{file.title}</h3>
            <p>Tamanho do arquivo: ({file.filesize})</p>
            <a href={`${API_URL}/documents/download/${encodeURIComponent(file.filename)}?download=1`} target="_blank" rel="noreferrer" className="little-pdf-button">
              Download
              <img alt="Icone pdf" src={pdfIcon} height="22px" />
            </a>
          </div>
          {index < files.length - 1 && (<div className="row-divider" />)}
        </React.Fragment> 
      ))}
    </div>
  )
}

export default FileList;